// export const BASE_URL = process.env.REACT_MODE==="local"?"process.env.REACT_APP_API_URL":"https://dev-api.prontocommerce.com/"
console.log(process.env.REACT_APP_MODE);
// export const BASE_URL =
//   process.env.REACT_APP_MODE === "local"
//     ? process.env.REACT_APP_API_URL
//     : "https://connect-server-ia06.onrender.com";

export const BASE_URL = process.env.REACT_APP_API_URL;

//export const BASE_URL = process.env.REACT_MODE=="https://dev-api.prontocommerce.com/"
//export const BASE_URL = "http://localhost:9000"
